<forge-card class="charge-card">
  <forge-expansion-panel>
    <div slot="header" role="button" tabindex="0">
      <forge-label-value>
        <label for="span-statute" slot="label">{{charge.statute?.degree | na}}</label>
        <span id="span-statute" slot="value">{{charge.statute?.description | na}}</span>
      </forge-label-value>
      <forge-open-icon></forge-open-icon>
    </div>
    <forge-divider></forge-divider>
    <div class="charge-details">
      <div class="charge-details-item">
        <span class="label">Charge Disposition</span>
        <span class="value no-value">{{charge.disposition | na}}</span>
      </div>
      <div class="charge-details-item">
        <span class="label">Case number</span>
        <span class="value">{{charge.caseNumber | na}}</span>
      </div>
      <div class="charge-details-item">
        <span class="label">Arrest date / time</span>
        <span class="value">{{ arrest.arrestDate | date:'MMMM dd, yyyy - h:mm a' }}</span>
      </div>
      <div class="charge-details-item triple">
        <span class="label">Arresting agency</span>
        <span class="value">{{arrest.arrestingAgency}}</span>
      </div>
    </div>
  </forge-expansion-panel>
</forge-card>